import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Field } from "@/components/admin/fields";

const CHANNELS = [
  { key: "meta_pixel_id", label: "Meta Pixel ID", hint: "Facebook & Instagram ads — Events Manager → Data Sources", testid: "marketing-meta" },
  { key: "tiktok_pixel_id", label: "TikTok Pixel ID", hint: "TikTok Ads Manager → Assets → Events", testid: "marketing-tiktok" },
  { key: "google_tag_id", label: "Google Tag ID", hint: "GA4 or Google Ads — looks like G-XXXXXX or AW-XXXXXX", testid: "marketing-google" },
  { key: "snapchat_pixel_id", label: "Snapchat Pixel ID", hint: "Snapchat Ads Manager → Events Manager", testid: "marketing-snapchat" },
];

export const MarketingTab = () => {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  if (!settings) return <p className="text-zinc-400 text-sm py-12">Loading marketing settings…</p>;
  const marketing = settings.marketing || {};

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", {
        announcement: settings.announcement,
        marquee_items: settings.marquee_items,
        banners: settings.banners,
        marketing,
      });
      toast.success("Marketing pixels connected — tracking site-wide now");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-3xl" data-testid="marketing-tab">
      <p className="font-serif text-2xl text-zinc-900">Social & Ad Pixels</p>
      <p className="text-sm text-zinc-500 mt-2 mb-10 leading-relaxed">
        Paste a pixel ID and it fires on every page — pageviews are tracked instantly, ready for your Meta, TikTok,
        Google and Snapchat campaigns. Leave blank to keep a channel off.
      </p>
      <div className="space-y-8">
        {CHANNELS.map((c) => (
          <div key={c.key} className="border border-zinc-200 p-6">
            <Field
              label={c.label}
              value={marketing[c.key] || ""}
              onChange={(e) => setSettings((s) => ({ ...s, marketing: { ...(s.marketing || {}), [c.key]: e.target.value.trim() } }))}
              data-testid={c.testid}
            />
            <p className="text-[11px] text-zinc-400 mt-2">{c.hint}</p>
            {marketing[c.key] && <p className="text-[10px] uppercase tracking-[0.2em] text-emerald-500 mt-2">● Connected</p>}
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} data-testid="marketing-save-btn" className="mt-8 bg-gold text-white text-xs uppercase tracking-[0.3em] px-10 py-4 hover:bg-champagne transition-colors duration-300 disabled:opacity-50">
        {saving ? "Saving…" : "Save & Connect"}
      </button>
    </div>
  );
};
